<template>
  <ContentLoop
    :class="$b()"
    :rows="[headingRow, columnRow]"
    nested
  />
</template>

<script>
export default {
  name: 'LPProductSection',

  props: {
    stack: { type: Array, required: true },
    products: { type: Array, required: true },
    title: { type: String, required: true },
    titleTag: { type: String, default: 'h2' },
    subtitle: { type: String, default: '' }
  },

  computed: {
    headingRow () {
      return {
        type: 'heading',
        title: this.title,
        titleSize: 'xl',
        titleTag: this.titleTag,
        copy: this.subtitle,
        copySize: 'md'
      }
    },
    columnRow () {
      return {
        type: 'multi_column',
        visibility: 'everywhere',
        skuPattern: '.*',
        id: this.stack.id,
        disableBottomMargin: true,
        columns: this.columns
      }
    },
    columns () {
      return [
        {
          ...this.stack[0],
          showCta: false
        },
        ...this.products
      ].filter(col => col)
    }
  }
}
</script>

<style lang="postcss">
.LPProductSection {
  @apply w-full;
}
</style>
